(() => {
  const productCache = new Map();
  const money = (cents) => {
    if (typeof cents !== 'number') return '';
    const currency = window.Shopify?.currency?.active || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', { style: 'currency', currency }).format(cents / 100); }
    catch (_) { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100); }
  };
  const productHandle = (href) => {
    try {
      const url = new URL(href, location.origin);
      if (url.origin !== location.origin) return '';
      const match = url.pathname.match(/\/products\/([a-z0-9-]+)\/?$/i);
      return match ? match[1].toLowerCase() : '';
    } catch (_) { return ''; }
  };
  const productUrl = (handle) => (window.Shopify?.routes?.root || '/') + 'products/' + encodeURIComponent(handle);
  const arrowIcon = () => {
    const arrow = element('span', 'te-voices__product-arrow');
    arrow.setAttribute('aria-hidden', 'true');
    arrow.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false"><path d="M7 17L17 7M8 7H17V16" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    return arrow;
  };
  const loadProduct = (handle) => {
    if (!productCache.has(handle)) {
      productCache.set(handle, fetch(productUrl(handle) + '.js', { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error('Produit indisponible');
          return response.json();
        }).catch(() => null));
    }
    return productCache.get(handle);
  };
  const imageUrl = (source, width) => {
    if (!source) return '';
    try {
      const url = new URL(source, location.origin);
      if (!['http:', 'https:'].includes(url.protocol)) return '';
      if (url.hostname.endsWith('shopify.com') || url.hostname.endsWith('shopifycdn.com')) url.searchParams.set('width', String(width));
      return url.href;
    } catch (_) { return ''; }
  };
  const element = (tag, className, content) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  };

  const init = (section) => {
    if (section.dataset.teVoicesReady === 'true') return;
    const source = section.querySelector('[data-te-voices-source]');
    const grid = section.querySelector('[data-te-voices-grid]');
    const viewport = section.querySelector('[data-te-voices-viewport]');
    const action = section.querySelector('.te-voices__action');
    const toggle = section.querySelector('[data-te-voices-toggle]');
    const summary = section.querySelector('[data-te-voices-summary]');
    if (!source || !grid || !viewport || !action || !toggle) return;

    const build = () => {
      const cards = [...source.querySelectorAll('.jdgm-testimonials-carousel .jdgm-card')];
      if (!cards.length) return false;
      const currentHandle = productHandle(section.dataset.productPath || location.pathname);
      const reviews = cards.map((card) => {
        const link = card.querySelector('.jdgm-product-name a');
        const href = link?.getAttribute('href') || '';
        const handle = productHandle(href);
        return {
          id: card.dataset.reviewId,
          text: card.querySelector('.jdgm-text')?.textContent?.trim() || '',
          stars: card.querySelectorAll('.jdgm-stars .jdgm--on').length,
          name: card.querySelector('.jdgm-reviewer-name')?.textContent?.trim() || 'Client',
          productName: link?.textContent?.trim() || '',
          handle,
          sameProduct: handle === currentHandle
        };
      }).filter((review) => review.handle && review.text && review.stars > 0)
        .filter((review, index, all) => all.findIndex((item) => item.id && review.id ? item.id === review.id : item.text === review.text && item.name === review.name) === index)
        .sort((a, b) => {
          const score = (review) => (review.sameProduct ? 1000 : 0) + (review.stars === 5 ? 100 : 0) + (review.text.length >= 45 ? 40 : 0) + Math.min(review.text.length, 170) / 10;
          return score(b) - score(a);
        }).slice(0, 13);
      if (!reviews.length) return false;

      const leadCandidate = (review) => review.stars === 5 && review.text.length >= 50 && review.text.length <= 130 && !/^(anonyme|client)$/i.test(review.name) && !/\b(trop|petit|juste|courtes|déçu)\b/i.test(review.text);
      let leadIndex = reviews.findIndex((review) => review.sameProduct && leadCandidate(review));
      if (leadIndex < 0) leadIndex = reviews.findIndex(leadCandidate);
      if (leadIndex < 0) leadIndex = 0;
      if (leadIndex > 0) reviews.unshift(reviews.splice(leadIndex, 1)[0]);

      const pending = [];
      const renderedCards = [];
      const moreRows = [];
      const fragment = document.createDocumentFragment();
      reviews.forEach((review, index) => {
        const isLead = index === 0;
        const card = element('article', 'te-voices__card' + (isLead ? ' te-voices__card--lead' : ''));
        if (index >= 5) card.hidden = true;
        let cover;
        if (isLead) {
          cover = element('img', 'te-voices__cover');
          cover.alt = '';
          cover.loading = 'lazy';
          cover.decoding = 'async';
          card.append(cover, element('div', 'te-voices__cover-shade'));
        }
        const content = element('div', 'te-voices__card-content');
        const top = element('div', 'te-voices__card-top');
        const stars = element('span', 'te-voices__stars', '★'.repeat(review.stars) + '☆'.repeat(Math.max(0, 5 - review.stars)));
        stars.setAttribute('aria-label', review.stars + ' étoiles sur 5');
        top.append(stars);
        if (review.sameProduct && !isLead) top.append(element('span', 'te-voices__card-tag', 'Cette pièce'));
        const quote = element('p', 'te-voices__quote', '« ' + review.text + ' »');
        const byline = element('p', 'te-voices__byline');
        byline.append(element('strong', '', review.name));
        const product = element('a', 'te-voices__product');
        product.href = productUrl(review.handle);
        product.setAttribute('aria-label', 'Voir ' + review.productName);
        const thumbnail = element('span', 'te-voices__product-thumb');
        const thumbImage = element('img', 'te-voices__product-image');
        thumbImage.alt = '';
        thumbImage.loading = 'lazy';
        thumbImage.decoding = 'async';
        thumbnail.append(thumbImage);
        const productCopy = element('span', 'te-voices__product-copy');
        const productTitle = element('strong', 'te-voices__product-title', review.productName);
        const productPrice = element('span', 'te-voices__product-price');
        productCopy.append(productTitle, productPrice);
        product.append(thumbnail, productCopy, arrowIcon());
        content.append(top, quote, byline, product);
        card.append(content);
        if (index < 5) fragment.append(card);
        renderedCards.push(card);
        pending.push(() => loadProduct(review.handle).then((data) => {
          if (!data) return;
          if (data.title) {
            productTitle.textContent = data.title;
            product.setAttribute('aria-label', 'Voir ' + data.title);
          }
          productPrice.textContent = money(data.price);
          const thumb = imageUrl(data.featured_image || data.images?.[0], 150);
          if (thumb) { thumbImage.src = thumb; thumbnail.classList.add('has-image'); }
          if (cover) {
            const photo = imageUrl(data.featured_image || data.images?.[0] || data.images?.[1], 900);
            if (photo) { cover.src = photo; card.classList.add('has-cover'); }
          }
        }));
      });
      for (let start = 5; start < renderedCards.length; start += 4) {
        const row = element('div', 'te-voices__more-row');
        const end = Math.min(start + 4, renderedCards.length);
        row.hidden = true;
        row.style.setProperty('--te-voices-more-columns', String(end - start));
        for (let index = start; index < end; index += 1) row.append(renderedCards[index]);
        fragment.append(row);
        moreRows.push(row);
      }
      grid.replaceChildren(fragment);

      const rating = source.querySelector('.jdgm-average-rating .jdgm-rating-text');
      if (rating && summary) {
        const match = rating.textContent.match(/([\d.,]+).*?\((\d+)\)/);
        if (match) {
          const stars = element('span', 'te-voices__summary-stars', '★★★★★');
          summary.replaceChildren(stars, document.createTextNode(' ' + match[1] + '/5 · ' + match[2] + ' avis sur la boutique'));
          summary.hidden = false;
        }
      }
      section.dataset.teVoicesReady = 'true';
      source.setAttribute('aria-hidden', 'true');
      source.inert = true;
      section.hidden = false;
      viewport.hidden = false;

      let visibleCount = Math.min(5, reviews.length);
      if (visibleCount >= reviews.length) viewport.classList.add('is-open');
      const updateAction = () => { action.hidden = visibleCount >= reviews.length; };
      requestAnimationFrame(updateAction);
      window.addEventListener('resize', updateAction, { passive: true });
      let initialHydrated = false;
      const hydrateInitial = () => {
        if (initialHydrated) return;
        initialHydrated = true;
        pending.slice(0, visibleCount).forEach((hydrate) => hydrate());
      };
      if ('IntersectionObserver' in window && !window.Shopify?.designMode) {
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          hydrateInitial();
        }, { rootMargin: '1000px 0px' });
        observer.observe(section);
      } else {
        hydrateInitial();
      }
      toggle.addEventListener('click', () => {
        if (visibleCount >= reviews.length) return;
        hydrateInitial();
        const nextCount = Math.min(visibleCount + 4, reviews.length);
        const row = moreRows[Math.floor((visibleCount - 5) / 4)];
        if (row) row.hidden = false;
        for (let index = visibleCount; index < nextCount; index += 1) {
          renderedCards[index].hidden = false;
          pending[index]();
        }
        visibleCount = nextCount;
        viewport.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
        if (visibleCount >= reviews.length) action.hidden = true;
      });
      return true;
    };

    if (build()) return;
    const observer = new MutationObserver(() => { if (build()) observer.disconnect(); });
    observer.observe(source, { childList: true, subtree: true });
    if (!window.Shopify?.designMode) section.hidden = true;
  };
  const initAll = (root = document) => {
    if (root.matches?.('[data-te-voices]')) init(root);
    root.querySelectorAll('[data-te-voices]').forEach(init);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
